import Text from 'components/priority/Text/Text'
import * as S from './ToastAction.styled'

export const ToastAction = ({ text, removeToast, onClick }) => (
  <S.ToastAction
    center
    clickable
    margin="0 0 0 8px"
    radius="2px"
    padding="4px"
    border="1px solid"
    borderColor="white"
    transition="0.25s"
    onClick={() => {
      onClick?.()
      removeToast()
    }}
  >
    <Text size="12px" weight="600" color="white">
      {text}
    </Text>
  </S.ToastAction>
)

export default ToastAction
